import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

// Detail-page search params: only `mask` matters (mirrors the staff
// `shouldMask` pattern — defaults to true; explicit `?mask=false` reveals the
// raw event payload).
export const Route = createFileRoute("/app/inbox/$leadId")({
  validateSearch: z.object({
    mask: z.string().optional(),
  }),
});
